/**
 * Record
 */
import $ from 'jquery';
import TweenMax from 'gsap/TweenMax';
import AbsSection from './AbsSection';
// import Config from '../module/Config';
import Dropdown from '../module/Dropdown';

export default class Record extends AbsSection {
  constructor(_containerID, _scrollMagicCon) {
    super(_containerID, _scrollMagicCon);

    const _ = this;

    _.$body = $('body');
    // _.$sectionIntro = $(_containerID);
    _._$titleDeco = $('.el_title_deco', _.$wrap);
    _._$title = $('.section-title', _.$wrap);
    _._$joinInfo = $('.join-info-wrap', _._$wrap);

    _.init();
  }

  init() {
    const _ = this;

    _._setDropdown();

  }

  _setDropdown() {
    const _ = this,
      $node = $('.ui-dropdown', _._$wrap);

    if ($node.length)
      _._phoneTypeDropdown = new Dropdown({
        $node: $node,
        prefix: 'ui-dropdown',
        selectedClass: 'is-selected'
        // selectCallback
      }).init();
  }


  animationIn() {
    const _ = this;

    console.log('Record in');
    TweenMax.killTweensOf(_._$titleDeco);
    TweenMax.killTweensOf(_._$title);
    TweenMax.killTweensOf(_._$joinInfo);

    TweenMax.fromTo(
      _._$titleDeco,
      0.8, {
        autoAlpha: 0,
        y: 10
      }, {
        scale: 1,
        autoAlpha: 1,
        y: 0,
        ease: Cubic.easeInOut
      }
    );

    TweenMax.fromTo(
      _._$title,
      0.8, {
        autoAlpha: 0
      }, {
        delay: 0.3,
        scale: 1,
        autoAlpha: 1,
        y: 0,
        ease: Cubic.easeInOut
      }
    );

    TweenMax.fromTo(
      _._$joinInfo,
      0.8, {
        autoAlpha: 0,
        y: 10
      }, {
        delay: 0.5,
        scale: 1,
        autoAlpha: 1,
        y: 0,
        ease: Cubic.easeInOut
      }
    );
  }

  animationOut() {
    console.log('Record out');
  }

  resize(evt) {
    // override
    const _ = this;

    _.setHeight(evt);
  }
}